import type { CardStack, ParentCardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"

/** Whether the followed lesson has been saved since it was copied. A comment counts as a save. */
export function changedSinceCopied(parentCardStack: ParentCardStack, followedLesson: CardStack) {
  return parentCardStack.version !== followedLesson.attributes.version
}

export type FollowedCourseUnavailableReason = "deleted" | "just-notes" | "no-access"

/** Why a followed class can't be shown to its follower, or null when it can. */
export function followedCourseUnavailableReason(
  course: Course,
  planbook: Planbook,
): FollowedCourseUnavailableReason | null {
  // Deleting a class only takes it out of its planbook: the course document stays readable.
  if (
    planbook.attributes.deletedAt !== null ||
    !planbook.relationships.courses.data.some((linkage) => linkage.id === course.id)
  ) {
    return "deleted"
  }
  if (course.attributes.isNonInstructional) return "just-notes"
  if (!course.meta.permissions.includes("can-view-plan")) return "no-access"
  return null
}
